import Extend from 'flarum/common/extenders';
import isDark from 'flarum/common/utils/isDark';
import Tag from 'ext:flarum/tags/common/models/Tag';
import { cssUrl } from './pixelArt';
export { cssUrl };

// Per-tag pixel settings from Admin → Tags (see extend.php).
export const tagModelExtenders = [new Extend.Model(Tag).attribute('pixmmoBackgroundUrl').attribute('pixmmoIcon').attribute('pixmmoAnimation')];
export function tagBackgroundUrl(tag) {
  return tag && tag.pixmmoBackgroundUrl && tag.pixmmoBackgroundUrl() || null;
}
export function tagIcon(tag) {
  return tag && tag.pixmmoIcon && tag.pixmmoIcon() || null;
}
export function tagAnimation(tag) {
  return tag && tag.pixmmoAnimation && tag.pixmmoAnimation() || null;
}

/** Custom properties for a tag's pixel styling: its colour, a readable colour on top of it, and its background image. */
export function tagStyleVars(tag) {
  const color = tag.color();
  const background = tagBackgroundUrl(tag);
  const vars = {};
  if (color) {
    vars['--px-cat-color'] = color;
    vars['--px-cat-on'] = isDark(color) ? '#fafafa' : '#09090b';
  }
  if (background) vars['--px-cat-bg'] = cssUrl(background);
  return vars;
}
flarum.reg.add('soup-97-pixmmo-pixelui', 'common/tagImages', { cssUrl: cssUrl,tagModelExtenders: tagModelExtenders,tagBackgroundUrl: tagBackgroundUrl,tagIcon: tagIcon,tagAnimation: tagAnimation,tagStyleVars: tagStyleVars, });